<div class="container">
  <app-navbar title="User Profile"></app-navbar>
  <div class="row" style="margin-top: 30px">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header">
          <i class="material-icons">perm_identity</i>
        </div>
        <div class="card-content">
          <h4 class="card-title">Edit Profile -
            <small class="category">Complete your profile</small>
          </h4>
          <form>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="First Name" [(ngModel)]="firstName" value="Ci" name="firstName">
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="Last Name" [(ngModel)]="lastName" value="Clia" name="lastName">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="Address">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="City">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="Country">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field color="accent">
                  <input matInput type="text" placeholder="Postcode">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="textarea-label">About Me</label>
                <mat-form-field color="accent">
                  <textarea matInput placeholder="Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo."></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row action-btn">
              <button md-raised-button type="submit" class="btn btn-rose">UPDATE PROFILE</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card right-profile">
        <div class="profile">
          <img src="../../../assets/img/marc.jpg" alt="profile"/>
        </div>
        <h6>CEO / CO-FOUNDER</h6>
        <h4>{{ firstName }} {{ lastName }}</h4>
        <p>Don't be scared of the truth because we need to restart the human foundation in truth And I love you like
          Kanye loves Kanye I love Rick Owens’ bed design but the back is...</p>
        <button mat-raised-button class="btn btn-rose btn-round">CHANGE</button>
      </div>
    </div>
  </div>
</div>
